/* eslint-disable */

import apis from '../api'
import xmutils from '../libs/xmutils'

export default {
    install (Vue, options) {
        Vue.prototype.$api  = apis
        Vue.prototype.$xmutils  = xmutils
    }
}
